<template>
  <div>
    <banner />
    <div class="d-inline-block" style="width: 50%; font-size: 1rem !important">
      <p>
        CRT Hub provides cashflows and analytics on Credit Risk Transfer structured transactions including Bonds (STACR/CAS); 
        Reinsurance Products (ACIS/CIRT) and Mortgage Insurance (MI-ILN).
      </p>
      <p>
        CRT Hub allows users to evaluate their CRT positions using static CPR/CDR; 
        proprietary vectors and scenarios; or through integration with third party predictive modeling.
      </p>
    </div>
    <HomePageFooter />
  </div>
</template>
<script>
import Banner from './Banner';
import HomePageFooter from './HomePageFooter';

export default {
  components: {
    Banner,
    HomePageFooter
  }
}
</script>